export default __webpack_public_path__ + "static/media/rewards_icon_wellness.1ab09cf4.svg";